<template>
  <div class="upper-liquidFill" style="z-index: 666">
    <div class="liquidFillBox" :id="liquidFillId" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
  import {debounce} from "../../utils/util";
  export default {
    name: 'upper-liquid-fill',
    props: {
      liquidFillId: {
        type: String,
        default () {
          return 'upperLiquidFillId'
        }
      },
      width: {
        type: String,
        default () {
          return '100%'
        }
      },
      height: {
        type: String,
        default () {
          return '100%'
        }
      },
      liquidFillTitle: {
        type: String,
        default () {
          return ''
        }
      },
      titleStyle: {
        type: Object,
        default () {
          return  {}
        }
      },
      legendData: {
        type: Array,
        default () {
          return []
        }
      },
      xAxis: {
        type: Object,
        default () {
          return  {}
        }
      },
      yAxis: {
        type: Array,
        default () {
          return []
        }
      },
      series: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        hygrometer: null
      }
    },
    mounted () {
      this.drawLiquidfill()
      window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.resizeChart)
    },
    methods: {
      drawLiquidfill() {
        this.hygrometer = this.$echarts.init(document.getElementById(this.liquidFillId))
        this.hygrometer.setOption({
          tooltip: {
            show: true
          },
          series: this.series
        })
      },
      resizeChart: debounce(function () {
        this.hygrometer.resize()
      }, 100)
    },
    watch: {
      series (val) {
        this.drawLiquidfill()
      }
    }
  }
</script>

<style scoped>
  .upper-liquidFill {
    width: 100%;
    height: 100%;
  }
  .liquidFillBox>div {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/UpperEcharts/upperLiquidFill.vue